import React, { useState, useRef } from "react";
import { connect } from "react-redux";

import {
  EditOutlined,
  CalendarOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Button, Checkbox, Col, DatePicker, Input, Modal, Row, Select, Space, Switch, Table, Tooltip } from "antd";


const { Option } = Select;

export const PurchaseOrderHistory = (props) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: <Tooltip title={t("Retailer Name")}>{t("Retailer Name")}</Tooltip>,
      ellipsis: true,
      dataIndex: "retailerName",
    },
    {
      title: <Tooltip title={t("Product")}>{t("Product")}</Tooltip>,
      ellipsis: true,
      dataIndex: "product",
    },
    {
      title: (
        <Tooltip title={t("Purchase order date")}>
          {t("Purchase order date")}
        </Tooltip>
      ),
      ellipsis: true,
      dataIndex: "purchaseOrderDate",
    },
    {
      title: (
        <Tooltip title={t("Order Confirm Date")}>
          {t("Order Confirm Date")}
        </Tooltip>
      ),
      ellipsis: true,
      dataIndex: "orderConfirmDate",
    },
    {
      title: <Tooltip title={t("Status")}>{t("Status")}</Tooltip>,
      ellipsis: true,
      dataIndex: "status",
    },
    {
      title: <Tooltip title={t("Sale Per")}>{t("Sale Per")}</Tooltip>,
      ellipsis: true,
      dataIndex: "salePer",
    },
  ];

  const data = [
    {
      key: "1",
      retailerName: "Retailer 1",
      product: "Product1232",
      purchaseOrderDate: "10/10/2019",
      orderConfirmDate: "10/20/2019",
      status: "Confirmed",
      salePer: "User1",
    },
    {
      key: "2",
      retailerName: "Retailer 1",
      product: "Product1232",
      purchaseOrderDate: "10/10/2019",
      orderConfirmDate: "10/20/2019",
      status: "Confirmed",
      salePer: "User1",
    },
  ];

  return (
    <div className="form__fields">
      <div className="row magento__mapping">
        <div className="col-md-12">
          <div className="heading__block">
            <h4 class="workarea__heading mt-0 mb-0">
              {" "}
              {t("Purchase Order History")}{" "}
            </h4>
          </div>
        </div>
        <div className="divForm">
          <Table columns={columns} dataSource={data} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PurchaseOrderHistory);
